import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './app/providers/AuthContext';
import { TicketProvider } from './app/providers/TicketContext';
import { WidgetProvider } from './app/providers/WidgetContext';
import { FlowChartProvider } from './app/providers/FlowChartContext';
import { DebugProvider } from './app/providers/DebugContext';
import Login from './features/auth/Login';
import MainPage from './app/pages/MainPage';
// import { WebSocketProvider } from './features/websocket/WebSocketProvider'; // KAPALI - Kullanılmıyor
import { TicketWebSocketProvider } from './features/websocket/TicketWebSocketProvider';
import FullScreenLoader from './shared/ui/FullScreenLoader';
import useVersionCheck from './shared/hooks/useVersionCheck';

function App() {
  useVersionCheck();

  return (
    <Router>
      <AuthProvider>
        <DebugProvider>
          <WidgetProvider>
            {/* <WebSocketProvider> KAPALI - Kullanılmıyor */}
              <TicketProvider>
                <TicketWebSocketProvider>
                  <FlowChartProvider>
                    <FullScreenLoader />
                    <Routes>
                      <Route path="/login" element={<Login />} />
                      <Route path="/" element={<MainPage />} />
                    </Routes>
                  </FlowChartProvider>
                </TicketWebSocketProvider>
              </TicketProvider>
            {/* </WebSocketProvider> KAPALI - Kullanılmıyor */}
          </WidgetProvider>
        </DebugProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
